// extracted by mini-css-extract-plugin
module.exports = {"weddingPhotoGoodsWrap":"weddingPhotoGoods_style_weddingPhotoGoodsWrap__1lRN2"};